// This const is used for nothing except to make this file identifiable via its content.
// We search for "_sentry_release_injection_file" in the plugin to determine for sure that the file we look at is the release injection file.

// _sentry_release_injection_file

    var _global =
      typeof window !== 'undefined' ?
        window :
        typeof global !== 'undefined' ?
          global :
          typeof self !== 'undefined' ?
            self :
            {};

    _global.SENTRY_RELEASE={id:"3.7.32"};